import React, { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react';

const DEFAULT_WIDTH = '200px';

function Fulltext(props: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
    const [width, setWidth] = useState(DEFAULT_WIDTH);

    return (
        <input
            {...props}
            className='ml-5 mr-5'
            style={{
                width: width
            }}
            placeholder='najít...'
            onFocus={() => setWidth('100%')}
            onBlur={() => setWidth(DEFAULT_WIDTH)} />
    );
}

export default Fulltext;
